import { render, staticRenderFns } from "./post-form.vue?vue&type=template&id=df196d36&"
import script from "./post-form.ts?vue&type=script&lang=ts&"
export * from "./post-form.ts?vue&type=script&lang=ts&"
import style0 from "./post-form.scss?vue&type=style&index=0&lang=scss&_scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports